import { ITEM_TYPES, Shape, SHAPE_TYPES, TabKeys } from "../../../../types";
import { DraggableComponent } from "./DraggableComponent";
import { AnimationPreviewWrapper } from "./AnimationPreviewWrapper";
import { useTemplatesStatusStore } from "../../../../store/useTemplatesStatusStore";
import { useTemplateEditorStore } from "../../../../store/useTemplateEditorStore";
import { ShapeRenderer } from "./shapes/ShapeRenderer";

export const TemplateShapes = ({
  shapes,
  previewWidth,
  previewHeight,
  editable = false,
}: {
  shapes: Shape[];
  previewWidth: number;
  previewHeight: number;
  editable?: boolean;
}) => {
  const { updateShape } = useTemplateEditorStore((store) => ({
    updateShape: store.updateShape,
  }));

  const { setActiveTab, activeTab } = useTemplatesStatusStore((state) => ({
    setActiveTab: state.setActiveTab,
    activeTab: state.activeTab,
  }));

  return shapes.map((shape) => {
    const strokeWidth = Math.round((shape.stroke?.width ?? 0) * previewWidth);
    const doubleStrokeWidth = strokeWidth * 2;

    return editable ? (
      <DraggableComponent
        key={shape.id}
        position={shape.position}
        saveRatio={shape.shapeType === SHAPE_TYPES.CIRCLE}
        size={shape.size}
        rotation={shape.rotation}
        layerIndex={shape.layerIndex}
        onDragStop={updateShape}
        drag={true}
        resize={true}
        item={{
          id: shape.id,
          type: ITEM_TYPES.Shape,
          orientation: shape.orientation,
          shapeType: shape.shapeType,
        }}
        onFocus={() => {
          if (activeTab !== TabKeys.objects && activeTab !== TabKeys.motion) {
            setActiveTab(TabKeys.objects);
          }
        }}
        previewWidth={previewWidth}
        previewHeight={previewHeight}
        onRotate={(rotation) => updateShape({ id: shape.id, rotation })}
        stroke={shape.stroke}
      >
        <AnimationPreviewWrapper
          animations={shape.animations}
          previewWidth={previewWidth}
          previewHeight={previewHeight}
          itemId={shape.id}
          rotation={shape.rotation}
        >
          <ShapeRenderer
            shape={shape}
            previewWidth={previewWidth}
            previewHeight={previewHeight}
          />
        </AnimationPreviewWrapper>
      </DraggableComponent>
    ) : (
      <div
        key={shape.id}
        style={{
          position: "absolute",
          top: shape.position.y * previewHeight - strokeWidth,
          left: shape.position.x * previewWidth - strokeWidth,
          width: shape.size.width * previewWidth + doubleStrokeWidth,
          height: shape.size.height * previewHeight + doubleStrokeWidth,
          zIndex: shape.layerIndex,
          transformOrigin: "center",
          transform: shape.rotation
            ? `rotate(${shape.rotation}deg)`
            : undefined,
        }}
      >
        <ShapeRenderer
          shape={shape}
          previewWidth={previewWidth}
          previewHeight={previewHeight}
        />
      </div>
    );
  });
};
